import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #SEGMENTED-CONTROL
\*------------------------------------ */
.cat-c-segmented-control__header {
  position: relative;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
@media all and (min-width: 35rem) {
  .cat-c-segmented-control__header {
    flex-direction: row;
    align-items: baseline;
  }
}

.cat-c-segmented-control__list {
  display: flex;
  overflow: auto;
  margin: 0;
  position: relative;
  order: 2;
  width: fit-content;
  padding: 0;
  background: var(--cat-theme-color-background-subtle);
  outline: 1px solid var(--cat-theme-color-border-default);
  border-radius: calc(var(--size-base-unit) * 0.5);
  outline-offset: -1px;
}

::slotted(cat-segmented-control-item) {
  position: relative;
}
::slotted(cat-segmented-control-item):after {
  content: "";
  position: absolute;
  border-inline-end: 1px solid var(--cat-theme-color-border-default);
  inset-inline-end: 0;
  height: 50%;
  inset-block-end: 50%;
  transform: translateY(50%);
}

::slotted(cat-segmented-control-item:last-child):after,
::slotted(cat-segmented-control-item[isActive]):after {
  border-width: 0;
}

::slotted(cat-segmented-control-item:focus):after {
  border-width: 0;
}

::slotted(cat-segmented-control-item:first-child) {
  --cat-segmented-control-item-button-border-inline-start: 1px solid var(--cat-theme-color-border-default);
  --cat-segmented-control-item-button-border-start-start-radius: calc(var(--size-base-unit) * 0.5);
  --cat-segmented-control-item-button-border-start-end-radius: 0;
  --cat-segmented-control-item-button-border-end-start-radius: calc(var(--size-base-unit) * 0.5);
  --cat-segmented-control-item-button-border-end-end-radius: 0;
}

::slotted(cat-segmented-control-item:last-child) {
  --cat-segmented-control-item-button-border-inline-end: 1px solid var(--cat-theme-color-border-default);
  --cat-segmented-control-item-button-border-start-start-radius: 0;
  --cat-segmented-control-item-button-border-start-end-radius: calc(var(--size-base-unit) * 0.5);
  --cat-segmented-control-item-button-border-end-start-radius: 0;
  --cat-segmented-control-item-button-border-end-end-radius: calc(var(--size-base-unit) * 0.5);
}
`;
       